<template lang="pug">
.pracas-vtal
  .row.ac.col-s
    h1 V.TAL
    AbasVtal
  .bloco
    .cabecalho.row.ac.col-s
      h3 CIDADES COM ATIVIDADE REPRESADA
      span.sub Atividades presentes, sem job e sem praça. Recalculado a cada carga; a cidade some assim que a praça é cadastrada.
      Button.atualizar(layout="green-go white" @click="carregarPendencias" :loader="pend.carregando") ATUALIZAR
      Button.nova(layout="green-go" @click="abrirNova(null)" style="margin-left: 12px") + NOVA PRAÇA
    Loader(v-if="pend.carregando" layout="small")
    .vazio(v-else-if="!pend.lista.length")
      b Nenhuma cidade com atividade represada.
      span Todas as cidades com atividade presente têm praça.
    .lista(v-else)
      .pendencia.row.ac.col-s(v-for="p in pend.lista" :key="p.uf + '/' + p.cidade" :class="{ 'nao-reconhecida': !p.reconhecida }")
        .g3.g12-s.col
          label Cidade
          b {{ p.uf }} / {{ p.cidade }}
          small(v-if="p.reconhecida && p.grafias.length > 1") Grafias da V.tal: {{ p.grafias.join(', ') }}
          small(v-if="!p.reconhecida") Não encontrada no cadastro de cidades
        .g2.g12-s.col
          label Atividades represadas
          b.numero {{ p.sas }}
        .g3.g12-s.col
          label Agendas
          b {{ p.primeira_agenda | date }} a {{ p.ultima_agenda | date }}
        .g4.g12-s.row.je.ac
          Button(v-if="p.reconhecida" layout="green-go" @click="abrirNova(p)") CADASTRAR PRAÇA
          p.aviso-ti(v-else) Esta cidade não está no cadastro de cidades do portal. Acione a TI informando:&nbsp;
            b {{ p.grafias.join(', ') }}
    PracaForm(v-if="nova.aberta" :cidade="nova.cidade" :tipos="tipos" @salvo="pracaCadastrada" @cancelar="nova.aberta = false")

  .bloco.pracas
    .cabecalho.row.ac.col-s
      h3 PRAÇAS CADASTRADAS
      span.sub Clique na linha para alterar o tipo de serviço ou o CEP. A cidade não muda: para trocar, remova e cadastre outra.
    .filtro.row.ae.col-s
      .col
        label(for="filtro-uf") UF
        input.input#filtro-uf(v-model="filtro.uf" placeholder="UF" maxlength="2" @keyup.enter="carregarPracas")
      .col
        label(for="filtro-cidade") CIDADE
        input.input#filtro-cidade(v-model="filtro.cidade" placeholder="TRECHO DO NOME" @keyup.enter="carregarPracas")
      Button.buscar(layout="green-go" @click="carregarPracas" :loader="pracas.carregando") BUSCAR
      small {{ pracas.lista.length }} praça(s)
    Loader(v-if="pracas.carregando" layout="small")
    .vazio(v-else-if="!pracas.lista.length") Nenhuma praça com esse filtro.
    .lista(v-else)
      .item(v-for="pr in pracas.lista" :key="pr.id" :class="{ parada: !pr.abre_job }")
        .titulo.row.ac.col-s(@click="alternarEdicao(pr.id)")
          .g3.g12-s.col
            label Cidade
            b {{ pr.cidade.uf }} / {{ pr.cidade.nome }}
          .g4.g12-s.col
            label Tipo de serviço
            b {{ pr.tipo_servico.id }} · {{ pr.tipo_servico.nome }}
          .g2.g12-s.col
            label CEP de referência
            b {{ pr.cep_referencia | cep }}
          .g2.g12-s.col
            label Robô
            span.pill(:class="pr.abre_job ? 'ok' : 'erro'") {{ pr.abre_job ? 'abre job' : 'parada' }}
          .g1.row.je.g12-s
            Button.fa(:class="editando.includes(pr.id) ? 'fa-times' : 'fa-edit'" :layout="editando.includes(pr.id) ? 'red-go' : 'green-go'")
        p.alerta-parada(v-if="!pr.abre_job") Tipo de serviço inativo. As atividades desta cidade estão paradas até o tipo ser reativado no cadastro de tipos ou trocado aqui.
        .editar(v-if="editando.includes(pr.id)")
          p.conflito(v-if="conflitos[pr.id]") Esta praça foi alterada por outro usuário. Os dados foram recarregados; confira e repita.
          PracaForm(:praca="pr" :cidade="pr.cidade" :tipos="tipos" @salvo="pracaAlterada" @conflito="recarregarPraca" @cancelar="alternarEdicao(pr.id)")
          .detail.row.ae.js.col-s
            span Criado em&nbsp;
              b {{ pr.criado_em | datetime }}
              | &nbsp;por&nbsp;
              b {{ pr.nome_criado_por }}
            span(v-if="pr.alterado_em") Alterado em&nbsp;
              b {{ pr.alterado_em | datetime }}
              | &nbsp;por&nbsp;
              b {{ pr.nome_alterado_por }}
            span.etag etag {{ pr.etag }}
            Button.remover(layout="red-go" @click="remover(pr)" :loader="bloader") REMOVER PRAÇA
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";
import AbasVtal from "@/views/admin/components/AbasVtal";
import PracaForm from "@/views/admin/components/PracaForm";

export default {
  name: "PracasVtal",
  components: { Button, Loader, AbasVtal, PracaForm },
  data() {
    return {
      tipos: [],
      pend: { carregando: false, lista: [] },
      nova: { aberta: false, cidade: null },
      filtro: { uf: "", cidade: "" },
      pracas: { carregando: false, lista: [] },
      editando: [],
      conflitos: {},
      bloader: false,
    };
  },
  mounted() {
    this.carregarPendencias()
    this.carregarTipos()
    this.carregarPracas()
  },
  methods: {
    ...mapActions("admin", ["PRACA_PENDENCIAS", "PRACA_TIPOS", "PRACA_LISTA", "PRACA_GET", "PRACA_EXCLUIR"]),
    ...mapMutations("general", ["SET_STATUS"]),
    async carregarTipos() {
      let r = await this.PRACA_TIPOS()
      if (r.status == 200) this.tipos = r.data
    },
    async carregarPendencias() {
      this.pend.carregando = true
      let r = await this.PRACA_PENDENCIAS()
      if (r.status == 200) this.pend.lista = r.data
      this.pend.carregando = false
    },
    abrirNova(p) {
      // Com a pendência, a cidade vai travada; sem ela, o formulário busca a cidade.
      this.nova.cidade = p ? { id: p.id_cidade, uf: p.uf, nome: p.cidade } : null
      this.nova.aberta = true
    },
    async pracaCadastrada(praca) {
      this.nova.aberta = false
      this.SET_STATUS({ text: `Praça cadastrada. As atividades represadas de ${praca.cidade.nome} viram job na próxima execução do robô (até dez minutos).`, color: "green" })
      await Promise.all([this.carregarPendencias(), this.carregarPracas()])
    },
    async carregarPracas() {
      this.pracas.carregando = true
      let f = { ...this.filtro }
      Object.keys(f).forEach(k => f[k] === "" && delete f[k])
      let r = await this.PRACA_LISTA(f)
      if (r.status == 200) this.pracas.lista = r.data
      this.pracas.carregando = false
    },
    alternarEdicao(id) {
      let i = this.editando.indexOf(id)
      if (i >= 0) {
        this.editando.splice(i, 1)
        this.$delete(this.conflitos, id)
      } else this.editando.push(id)
    },
    async pracaAlterada(praca) {
      this.alternarEdicao(praca.id)
      this.SET_STATUS({ text: "Praça alterada. Jobs já abertos continuam no tipo em que nasceram.", color: "green" })
      await this.carregarPracas()
    },
    // 412 na alteração: outro usuário mexeu antes. Recarrega a praça e pede para conferir e repetir.
    async recarregarPraca(id) {
      let r = await this.PRACA_GET(id)
      if (r.status == 404) {
        this.SET_STATUS({ text: "Esta praça foi removida por outro usuário.", color: "orange" })
        this.alternarEdicao(id)
        return this.carregarPracas()
      }
      if (r.status != 200) return
      let i = this.pracas.lista.findIndex(p => p.id === id)
      if (i >= 0) this.$set(this.pracas.lista, i, r.data)
      this.$set(this.conflitos, id, true)
    },
    async remover(pr) {
      if (!window.confirm(`Remover a praça de ${pr.cidade.nome}? As atividades desta cidade voltam a ficar paradas até uma nova praça ser cadastrada.`)) return
      this.bloader = true
      let r = await this.PRACA_EXCLUIR(pr.id)
      this.bloader = false
      if (r.status != 200) return
      this.SET_STATUS({ text: `Praça removida. ${r.data.sas_represadas} atividade(s) presentes sem job ficam aguardando nova praça.`, color: "green" })
      this.editando = this.editando.filter(id => id !== pr.id)
      await Promise.all([this.carregarPendencias(), this.carregarPracas()])
    },
  },
};
</script>

<style lang="sass" scoped>
@use "sass:color"
@use "@/assets/scss/vars.scss" as *
.pracas-vtal
  @include page
  h1
    font-size: 32px
    margin: 0 24px 0 0
  .bloco
    @include card
    border-top-left-radius: 0
    .cabecalho
      margin-bottom: 16px
      h3
        margin: 0
        font-size: 15px
        letter-spacing: .5px
      .sub
        flex: 1
        color: $gray-5
        font-size: 12px
        margin: 0 14px
  .pracas
    margin-top: 28px
    border-top-left-radius: 23px
  label
    @include label
  .vazio
    padding: 28px 10px
    text-align: center
    color: $gray-5
    b
      display: block
      color: $green-6
      font-size: 16px
      margin-bottom: 4px
  .pendencia
    border: 1.6px solid #ccc
    border-radius: 12px
    padding: 14px 18px
    margin-top: 10px
    background: white
    &:hover
      border-color: $purple
    &.nao-reconhecida
      background: rgba($orange-1, .15)
      border-style: dashed
    b
      font-size: 15px
    small
      color: $gray-5
      font-size: 12px
    .numero
      font-size: 22px
      color: $purple
    .aviso-ti
      margin: 0
      font-size: 13px
      line-height: 1.45
      color: color.adjust($orange-1, $lightness: -25%)
  .filtro
    margin-bottom: 18px
    .col
      margin-right: 16px
      min-width: 120px
    .input
      box-sizing: border-box
    small
      color: $gray-5
      font-size: 12px
      margin-left: 12px
  .pracas .lista
    max-height: 70vh
    overflow: auto
  .item
    border: 1.6px solid #ccc
    border-bottom: 4px solid #ccc
    border-radius: 12px
    padding: 14px 18px
    margin-top: 10px
    background: white
    &:hover
      border-color: $purple
    &.parada
      border-left: 6px solid $red
    .titulo
      cursor: pointer
      b
        font-size: 14px
  .pill
    display: inline-block
    padding: 3px 10px
    border-radius: 40px
    font-size: 12px
    font-weight: bold
    &.ok
      background: $green-3
      color: $green-6
    &.erro
      background: $red-6
      color: $red
  .alerta-parada
    margin: 10px 0 0
    padding: 8px 12px
    background: $red-6
    color: $red
    border-radius: 8px
    font-size: 13px
  .editar
    background: rgba(#f1f1f1, .7)
    border-radius: 12px
    padding: 20px
    margin-top: 16px
  .conflito
    margin: 0 0 12px
    padding: 10px 14px
    background: rgba($orange-1, .15)
    color: color.adjust($orange-1, $lightness: -25%)
    border-radius: 8px
    font-size: 13px
  .detail
    padding: 22px 10px 4px
    font-size: 13px
    color: $gray-5
    span
      margin-right: 28px
    .etag
      font-family: monospace
      color: $gray-9
</style>
